import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from '@/components/ui/button';
import { cn } from '@/utils';
import { useCreatePromptMutation } from '@/store/api/promptApi';

const CATEGORIES = [
  { label: 'Tech', value: 'Tech' },
  { label: 'Semi Tech', value: 'SemiTech' },
  { label: 'Non Tech', value: 'NonTech' },
];

export default function PromptInput({ className }: { className?: string }) {
  const [category, setCategory] = useState('');
  const [prompt, setPrompt] = useState('');

  const [createPrompt, { isLoading }] = useCreatePromptMutation();

  const handleSubmit = async () => {
    // if (!category || !prompt.trim()) {
    //   toast.error('Please fill all fields');
    //   return;
    // }

    try {
      await createPrompt({
        prompt,
      }).unwrap();

      toast.success('Prompt submitted successfully ');

      setCategory('');
      setPrompt('');
    } catch {
      toast.error('Failed to submit prompt ');
    }
  };

  return (
    <div className={cn('space-y-4', className)}>
      {/* <select
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        className="w-full border rounded-md px-3 py-2 text-sm"
      >
        <option value="">Select Category</option>
        {CATEGORIES.map((cat) => (
          <option key={cat.value} value={cat.value}>
            {cat.label.toUpperCase()}
          </option>
        ))}
      </select> */}

      <textarea
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder="Enter your prompt here..."
        rows={5}
        className="w-full border rounded-md px-3 py-2 text-sm "
      />

      <Button onClick={handleSubmit} className="w-full" disabled={!prompt.trim() || isLoading}>
        {isLoading ? 'Createting...' : 'Create Prompt'}
      </Button>
    </div>
  );
}
